module.exports = __webpack_public_path__ + "static/media/lang0.237c31db.mp3";